import { Flex, Text, VStack } from '@chakra-ui/layout'
import React, { useEffect } from 'react'
import { AVAILABLE_ON, useExperimentsState } from '~/atoms/ExperimentsState'
import { useUserState } from '~/atoms/UserState'
import { NotificationBadge } from '~/components/shared/NotificationBadge'
import Logger from '~/services/Logger'
import { Size } from '~/types/ThemeTypes'
import { isElectron } from '~/utils/common'

import { SettingToggle } from './SettingItems'
import { DefaultSettingsWrapper, SubheadingSection } from './Shared'

export const ExperimentSettings = () => {
  const { experiments } = useExperimentsState()
  const logger = new Logger('ExperimentSettings')

  const { sessionUser } = useUserState()

  const experimentSections = experiments
    .map((experiment) => {
      if (
        experiment.internalOnly &&
        !sessionUser?.email?.endsWith('@mangovoice.com')
      ) {
        return null
      }

      if (experiment.availableOn === AVAILABLE_ON.DESKTOP && !isElectron) {
        return null
      } else if (experiment.availableOn === AVAILABLE_ON.WEB && isElectron) {
        return null
      }

      return (
        <SubheadingSection key={experiment.title}>
          <Flex alignItems={'center'}>
            <Text textStyle="Body2_Bold">{experiment.title}</Text>
            {experiment.badge && (
              <NotificationBadge
                count={experiment.badge?.text}
                size={Size.md}
                variant={experiment.badge?.styleVariant}
                sx={{
                  paddingLeft: '.5rem',
                }}
              />
            )}
          </Flex>
          <SettingToggle
            label={experiment.description}
            isChecked={experiment.enabled}
            onClick={() => {
              const newState = !experiment.enabled
              experiment.onSet(newState)
            }}
          />
          {experiment.children || null}
        </SubheadingSection>
      )
    })
    .filter((experiment) => {
      return experiment
    })

  useEffect(() => {
    experiments.forEach((experiment) => {
      if (experiment?.onLoad) {
        try {
          experiment.onLoad()
        } catch (e) {
          logger.error('Error during experiment load', e as Error | null)
        }
      }
    })
  }, [])

  return (
    <DefaultSettingsWrapper>
      <VStack w="full" gap="1rem">
        {experimentSections.length > 0 ? (
          experimentSections
        ) : (
          <SubheadingSection>
            <Text textStyle="Body2" color="gray.800">
              No experiments running at this time.
            </Text>
          </SubheadingSection>
        )}
      </VStack>
    </DefaultSettingsWrapper>
  )
}
